<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{new Date().getFullYear()}} © E-Triq. 
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Project Developed by <a target="_blank" href="https://thinkncode.com">Think N Code</a>
                </div>
            </div>
        </div>
    </div>
</footer>
</template>
